module.exports = __webpack_public_path__ + "static/media/22-3.b7d913e3.mp3";